<!-- eslint-disable max-len -->
<template>
  <div class="slider-inner" :class="{'slide-in': showTransporterSlider || shuffleActive}">
    <div class="slider-header px-15">
      <template>
        <div style="width: 82%;">&nbsp;</div>
      </template>
      <template v-if="$hasPermission('exclusive_draft_indent_creation')">
        <Button type="text" size="mini" @click="routeToIndent">{{$t('INDENT_CANCEL')}}</Button>
        <Button
          type="dark"
          size="mini"
          @click="createIndent(true, true)"
          @dblclick="createIndent(false, true)"
          :disabled="disableIndentButton"
          v-if="!isEditState && !this.$hasPermission('create_only_rfq_indent') && !currentIndent.first_in_allotment"
        >
          <span v-if="isCreateFromDraftState">{{$t('INDENT_UPDATE')}}</span>
          <span v-else>{{$t('INDENT_SAVE')}}</span>
          {{$t('INDENT_DRAFT')}}
        </Button>
      </template>
      <template v-else>
        <Button type="text" size="mini" @click="routeToIndent">{{$t('INDENT_CANCEL')}}</Button>
        <Button
          type="dark"
          size="mini"
          @click="createIndent(true, true)"
          @dblclick="createIndent(false, true)"
          :disabled="disableIndentButton"
          v-if="!isEditState && this.$hasPermission('draft_indent') && !this.$hasPermission('create_only_rfq_indent') && !currentIndent.first_in_allotment"
        >

          <span v-if="isCreateFromDraftState">{{$t('INDENT_UPDATE')}}</span>
          <span v-else>{{$t('INDENT_SAVE')}}</span>
          {{$t('INDENT_DRAFT')}}
        </Button>
        <Button type="primary" size="mini" @click="createIndent(true)" @dblclick="createIndent(false)" :disabled="disableIndentButton" v-if="!((isOpenIndent && currentIndent.rfq || (isContractIndent && currentIndent.first_in_allotment) ) || isMarketIndent)">
          <span v-if="(hideAllActions || isOnlyChangeTruckState || isEditState)">{{$t('INDENT_UPDATE')}}</span>
          <span v-else>{{$t('INDENT_INDENT')}}</span>
        </Button>
        <Tooltip v-if="(isOpenIndent && currentIndent.rfq) || isMarketIndent || (isContractIndent && currentIndent.first_in_allotment)" effect="dark" :disabled="!disableIndentButton"   placement="bottom-start">
          <div slot="content">{{getTooltipTitle}}</div>
          <span class="ml-10">
            <Button type="primary" size="mini" @click="createIndent(true)" @dblclick="createIndent(false)" :disabled="disableIndentButton">
              {{$t('INDENT_REQUEST')}}
            </Button>
          </span>
        </Tooltip>
      </template>
    </div>
    <Row class="d-flex">
      <Col :style="getColStyle">
      <div class="slider-body two-pane">
        <div class="popover-custom no-border with-shadow" placement="topright" v-if="showIndentPromptDropLimit">
          <div class="popover-body bg-white w-300">
            <p> {{$t('INDENT_LIMIT_MULTI_DROP_PTL_PROMPT',{IndentPromptLimit})}} </p>
            <div class="popover-footer">
              <Button type="text" size="mini" @click="disableIndentPromptDropLimit">
                {{$t('OK')}}
              </Button>
            </div>
          </div>
        </div>
        <div class="popover-custom no-border with-shadow" placement="topright" v-if="showIndentPrompt">
          <div class="popover-body bg-white w-300">
            <p> {{$t('INDENT_MULTI_DROP_PTL_PROMPT')}} </p>
            <div class="popover-footer">
              <Button type="text" size="mini" @click="reviseIndentCreation">
                {{$t('INDENT_CANCEL')}}
              </Button>
              <Button type="primary" size="mini" @click="createMultiplePtlIndents">
                {{$t('INDENT_PROMPT_PROCEED')}}
              </Button>
            </div>
          </div>
        </div>
        <div class="shuffle mb-10 mt-10" v-if="getPickupDrops.length">
          <div class="collapse-slider-header left-liner" :class="{'active': shuffleActive, 'is-disabled': showTransporterSlider }" @click="openShufflePane" v-if="lastMileEnabled">
            <div class="wp-100 d-flex">
              <div>
                {{$t('INDENT_PICKUP_AND_DROPOFF')}}
                <div style="font-size: 9px;">{{$t('INDENT_CHANGE_SEQUENCE_IF_REQUIRED')}}</div>
              </div>
                      <svgicon
                        class="arrow-indicator"
                        :name="!shuffleActive ? 'icon-accordion-arrow-right' : 'icon-accordion-arrow-left'"
                        width="20"
                        height="20"
                        :original="true" />
            </div>
          </div>
          <div v-else class="collapse-slider-header left-liner wp-100 d-flex">
            {{$t('INDENT_PICKUP_AND_DROPOFF')}}
          </div>
          <pickup-drop-timeline v-if="!shuffleActive" :pickupDrops="getPickupDrops" :resetSequence="resetSequence" @set-initial-sequence="setSequence" ref="viewPickupDropTimeline" />
        </div>
        <ul class="drawer-list list-flex">
          <li class="mb-5" v-if="isNoFreightIndent">
            <label>{{$t('INDENT_FREIGHT_TYPE')}}</label>
            <div class="list-content">
              <div v-if="isOnlyChangeTruckState || hideAllActions">
                {{freightTypeName}}
              </div>
              <Select
                v-else
                :value="currentIndent && currentIndent.freightType"
                align="right"
                size="mini"
                popper-class="select-dark-dropdown text-right"
                class="select-default select-dark"
                :disabled="showTransporterSlider"
                @input="changeIndentDetails($event, 'freightType')"
              >
                <Option
                  v-for="item in freightTypeList"
                  :key="item.id"
                  :label="$t(item.tlabel)"
                  :value="item.value"
                ></Option>
              </Select>
            </div>
          </li>
          <li class="mb-5">
            <label>{{$t('INDENT_DELIVERY_TYPE')}}</label>
            <div class="list-content">
              <div v-if="isOnlyChangeTruckState || hideAllActions || isEximIndent">
                {{currentIndent.deliveryType}}
              </div>
              <Select
                v-else
                :disabled="(!deliveryTypeList || !deliveryTypeList.length) && !showMasterData || showTransporterSlider || checkOpenIndentForDropOffs"
                :value="currentIndent && currentIndent.deliveryType"
                align="right"
                size="mini"
                popper-class="select-dark-dropdown text-right"
                class="select-default select-dark"
                @input="changeIndentDetails($event, 'deliveryType')"
              >
                <Option
                  v-for="item in deliveryTypeList"
                  :key="item.id"
                  :label="$t(item.tlabel)"
                  :value="item.id"
                ></Option>
              </Select>
            </div>
          </li>
          <li class="mb-5" v-if="!this.$hasFeature('transporter_based_vehicles')">
            <label>{{$t('INDENT_VEHICLE_TYPE')}}</label>
            <div class="list-content">
              <div v-if="hideAllActions && !isOnlyChangeTruckState">
                <Ellipsis
                  v-if="currentIndent.vehicleTypeName"
                  :text="currentIndent.vehicleTypeName"
                  length="20"/>
              </div>
              <div v-else-if="isOnlyChangeTruckState && (!vehicleTypesList || !vehicleTypesList.length)">
                <Ellipsis
                  v-if="currentIndent.vehicleTypeName"
                  :text="currentIndent.vehicleTypeName"
                  length="20"/>
              </div>
              <Select
                v-else
                filterable
                :disabled="!vehicleTypesList.length || !currentIndent.deliveryType || showTransporterSlider"
                :value="currentIndent && currentIndent.vehicleTypeId"
                align="right"
                size="mini"
                popper-class="select-dark-dropdown text-right"
                class="select-default select-dark"
                @input="(value) => { changeIndentDetails(value, 'vehicleTypeId');}"
              >
                <Option
                  v-for="item in vehicleTypesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></Option>
              </Select>
            </div>
          </li>
          <li class="mb-5" v-if="showBulkPTLIndentToggle">
             <label>{{$t('OPTIMA_BULK_PTL_INDENTS')}}
              <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom">
               <div slot="content"> When enabled, indents will be created based on source and destination grouping with multiple indents consolidated together</div>
               <svgicon name="icon-info-circle" width="12" height="12" :original="true" />
              </Tooltip>
             </label>
            <div class="list-content">
              <SwitchBtn
                :disabled="!showBulkPTLIndentToggle"
                :value="currentIndent.is_bulk_ptl_indent"
                size="small"
                label="right"
                :active-text="$t('INDENT_YES')"
                :inactive-text="$t('INDENT_NO')"
                class="default-switch switch-light"
                @change="changeIndentDetails($event, 'is_bulk_ptl_indent')"
              />
            </div>
          </li>
          <li class="mb-5" v-if="isFromOptima && currentIndent.vehicleTypeId && currentIndent.deliveryType">
            <label>{{$t('WEIGHT_UTILISATION')}}</label>
            <div class="list-content">
              <div>{{weightUtilisation}}%</div>
            </div>
          </li>
          <li class="mb-5" v-if="isFromOptima && currentIndent.vehicleTypeId && currentIndent.deliveryType">
            <label>{{$t('VOLUME_UTILISATION')}}</label>
            <div class="list-content">
              <div>{{volumeUtilisation}}%</div>
            </div>
          </li>
          <li class="mb-5" v-if="isOpenIndent && hasOpenRfqIndentConfig && !isEditState">
            <label>{{$t('INDENT_ENABLE_RFQ')}}</label>
            <div class="list-content">
              <SwitchBtn
                :disabled="isOnlyChangeTruckState || hideAllActions || $hasPermission('create_only_rfq_indent') || showTransporterSlider"
                :value="$hasPermission('create_only_rfq_indent') || currentIndent.rfq"
                size="small"
                label="right"
                :active-text="$t('INDENT_YES')"
                :inactive-text="$t('INDENT_NO')"
                class="default-switch switch-light"
                @change="changeIndentDetails($event, 'rfq')"
              />
            </div>
          </li>
          <li class="mb-5" v-if="!showTransporterSelection">
            <label>{{$t('INDENT_TRANSPORTER')}}</label>
            <div class="list-content">
              <div v-if="isMarketIndent ||
              (currentIndent.rfq && (isOnlyChangeTruckState || hideAllActions))">
                {{$t('INDENT_PANDO_NETWORK_TRANSPORTER')}}
              </div>
              <div v-else-if="isOnlyChangeTruckState || hideAllActions">
             <Ellipsis
                v-if="currentIndent.transporterName"
                :text="currentIndent.transporterName"
                length="20"/>
              </div>
            </div>
          </li>
          <li class="mb-5" v-if="this.$hasFeature('transporter_based_vehicles')">
            <label>{{$t('INDENT_VEHICLE_TYPE')}}</label>
            <div class="list-content">
              <div v-if="hideAllActions && !isOnlyChangeTruckState">
                <Ellipsis
                  v-if="currentIndent.vehicleTypeName"
                  :text="currentIndent.vehicleTypeName"
                  length="20"/>
              </div>
              <div v-else-if="isOnlyChangeTruckState && (!vehicleTypesList || !vehicleTypesList.length)">
                <Ellipsis
                  v-if="currentIndent.vehicleTypeName"
                  :text="currentIndent.vehicleTypeName"
                  length="20"/>
              </div>
              <Select
                v-else
                filterable
                :disabled="!vehicleTypesList.length || !currentIndent.deliveryType || showTransporterSlider"
                :value="currentIndent && currentIndent.vehicleTypeId"
                align="right"
                size="mini"
                popper-class="select-dark-dropdown text-right"
                class="select-default select-dark"
                @input="changeIndentDetails($event, 'vehicleTypeId')"
              >
                <Option
                  v-for="item in vehicleTypesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></Option>
              </Select>
            </div>
          </li>
          <li class="mb-5" v-if="!isEditState && !isFromOptima">
            <label>{{$t('INDENT_NO_OF_VEHICLES')}}</label>
            <div class="list-content">
              <div v-if="hideAllActions && !isOnlyChangeTruckState">
                {{currentIndent.no_of_vehicles}}
              </div>
              <Select
                v-else
                filterable
                :disabled="isMultiDropPtlRestricted || showTransporterSlider"
                :value="(currentIndent && currentIndent.no_of_vehicles) || 1"
                align="right"
                size="mini"
                popper-class="select-dark-dropdown text-right"
                class="select-default select-dark"
                @input="changeIndentDetails($event, 'no_of_vehicles')"
              >
                <Option
                  v-for="item in numberOfVehiclesList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></Option>
              </Select>
            </div>
          </li>
          <li class="mb-5" v-if="!isEditState && currentIndent.rfq && currentType === 1 && $hasPermission('view_rfq_ceiling_price')">
            <label>{{$t('BIDS_CEILING_PRICE')}}</label>
            <div class="list-content">
              <Input
                  type="number"
                  :placeholder="$t('INDENT_ENTER_CEILING_PRICE')"
                  size="xsmall"
                :value="currentIndent && currentIndent.ceiling_price"
                  @input="changeIndentDetails($event, 'ceiling_price')"
                  class="form-control"
                  :disabled="showTransporterSlider"
                >
              </Input>
            </div>
          </li>
          <li class="mb-5">
            <label>{{$t('Shipment NO.')}}</label>
            <div v-if="hideAllActions">
              {{ currentIndent && currentIndent.shipment_number }}
            </div>
            <div class="list-content" v-else>
                  <Input
                  type="text"
                  :placeholder="$t('INDENT_ENTER_SHIPMENT_NUMBER')"
                  size="xsmall"
                :disabled="isMultiDropPtlRestricted || showTransporterSlider"
                :value="currentIndent && currentIndent.shipment_number"
                  @input="changeIndentDetails($event, 'shipment_number')"
                  class="form-control"
                >
              </Input>
            </div>
          </li>
          <li class="mb-5" v-if="!isEditState && currentIndent.rfq && currentType === 1
          && $hasPermission('view_rfq_historical_price')">
            <label>{{$t('BIDS_HISTORICAL_PRICE')}}</label>
            <div class="list-content">
              <Input
                  type="number"
                  :placeholder="$t('INDENT_ENTER_HISTORICAL_PRICE')"
                  size="xsmall"
                :value="currentIndent && currentIndent.historical_price"
                  @input="changeIndentDetails($event, 'historical_price')"
                  class="form-control"
                  :disabled="showTransporterSlider"
                >
              </Input>
            </div>
          </li>
          <li class="mb-5" v-if="currentIndent.rfq && currentType === 1 || currentIndent.deliveryType === 'PTL'">
            <label>{{$t('INDENT_NO_OF_MATERIALS')}}</label>
            <div class="list-content">
              <Input
                  type="number"
                  :placeholder="$t('INDENT_ENTER_MATERIAL_COUNT')"
                  size="xsmall"
                :value="currentIndent && currentIndent.no_of_materials"
                  @input="changeIndentDetails($event, 'no_of_materials')"
                  class="form-control"
                  :disabled="showTransporterSlider"
                />
            </div>
          </li>
          <li class="mb-5" v-if="currentIndent.rfq && currentType === 1 || currentIndent.deliveryType === 'PTL'">
            <label>{{$t('INDENT_WEIGHT_KG')}}</label>
            <div class="list-content">
              <Input
                  type="number"
                  :placeholder="$t('INDENT_ENTER_MATERIAL_WEIGHT')"
                  size="xsmall"
                :value="currentIndent && currentIndent.material_weight"
                  @input="changeIndentDetails($event, 'material_weight')"
                  class="form-control"
                  :disabled="showTransporterSlider"
                />
            </div>
          </li>
          <li class="mb-5" v-if="currentIndent.rfq && currentType === 1 || currentIndent.deliveryType === 'PTL'">
            <label>{{$t('INDENT_VOLUME_TYPE')}}{{ `(${preferredVolumeUnit})` }}</label>
            <div class="list-content">
              <Input
                  type="number"
                  :placeholder="$t('INDENT_ENTER_MATERIAL_VOLUME')"
                  size="xsmall"
                  :value="currentIndent && currentIndent.material_volume"
                  @input="changeIndentDetails($event, 'material_volume')"
                  class="form-control"
                  :disabled="showTransporterSlider"
                />
            </div>
          </li>
          <li class="mb-5" v-if="isOpenIndent && $hasFeature('indent_freight_charge')">
            <label>{{$t('INDENT_FREIGHT_TYPE')}}</label>
            <div class="list-content">
              <div v-if="hideAllActions">
                {{ openFreightType(currentIndent.open_freight_type)}}
              </div>
              <Select
                v-else
                filterable
                :value="currentIndent && currentIndent.open_freight_type"
                align="right"
                size="mini"
                popper-class="select-dark-dropdown text-right"
                class="select-default select-dark"
                @input="changeIndentDetails($event, 'open_freight_type')"
                :disabled="showTransporterSlider"
              >
                <Option
                  v-for="item in contractTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></Option>
              </Select>
            </div>
          </li>
          <li class="mb-5" v-if="isOpenIndent && $hasFeature('indent_freight_charge') && !currentIndent.rfq">
            <label>{{$t('INDENT_BASE_FREIGHT')}}</label>
            <div v-if="hideAllActions">
              {{ currentIndent && currentIndent.freightRate }}
            </div>
            <div class="list-content" v-else>
              <Input
                  type="number"
                  :placeholder="currentClient.currency"
                  size="xsmall"
                  :value="currentIndent && currentIndent.freightRate"
                  @input="changeIndentDetails($event, 'freightRate')"
                  class="form-control"
                  :disabled="showTransporterSlider"
                >
              </Input>
            </div>
          </li>
          <li class="mb-5" v-if="isOpenIndent && $hasFeature('open_indent_details')">
            <label>{{$t('INDENT_FIELD_TRANSFER_TYPE')}}</label>
            <div class="list-content">
              <div v-if="hideAllActions || isEditState">{{ transferTypeLabel(currentIndent.transfer_type) }}</div>
              <Select
                  v-else
                  filterable
                  :value="currentIndent && currentIndent.transfer_type"
                  align="right"
                  size="mini"
                  popper-class="select-dark-dropdown text-right"
                  class="select-default select-dark"
                  @input="changeIndentDetails($event, 'transfer_type')"
              >
                <Option
                    v-for="item in transferTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></Option>
              </Select>
            </div>
          </li>
          <li class="mb-5" v-if="isOpenIndent && $hasFeature('open_indent_details')">
            <label>{{$t('INDENT_REMARKS')}}</label>
            <div class="list-content">
              <div v-if="hideAllActions || isEditState">{{ currentIndent.indent_remarks !== null && currentIndent.indent_remarks !== undefined && currentIndent.indent_remarks !== '' ? currentIndent.indent_remarks : '\u2014' }}</div>
              <Input
                  v-else
                  type="text"
                  :placeholder="$t('INDENT_ENTER_OPEN_REMARKS')"
                  size="xsmall"
                  :value="currentIndent && currentIndent.indent_remarks"
                  @input="changeIndentDetails($event, 'indent_remarks')"
                  class="form-control"
              >
              </Input>
            </div>
          </li>
          <li class="mb-5" v-if="$hasFeature('consider_return_freight_charge')">
            <label>{{$t('CONSIDER_RETURN_FRIEGHT_CHARGE')}}</label>
            <div class="list-content">
              <SwitchBtn
                :value="currentIndent && currentIndent.consider_return_freight_charge"
                :disabled="false"
                size="small"
                label="right"
                :active-text="$t('INDENT_YES')"
                :inactive-text="$t('INDENT_NO')"
                class="default-switch switch-light"
                @change="changeIndentDetails($event, 'consider_return_freight_charge')"
              />
            </div>
          </li>
          <li class="mb-5" v-if="showFirstInAllotment && this.$hasFeature('first_in_allotment') && !isOnlyChangeTruckState && !isEditState">
            <label>{{$t('INDENT_FIRST_IN_ALLOTMENT')}}</label>
            <div class="list-content">
              <SwitchBtn
                :value="currentIndent && currentIndent.first_in_allotment"
                :disabled="showTransporterSlider"
                size="small"
                label="right"
                :active-text="$t('INDENT_YES')"
                :inactive-text="$t('INDENT_NO')"
                class="default-switch switch-light"
                @change="changeIndentDetails($event, 'first_in_allotment')"
              />
            </div>
          </li>
          <li class="mb-5" v-if="showSobAndFreightDetails">
            <label>{{$t('SOB_EXISTS')}}</label>
            <div class="list-content">
              <div v-if="showSobDetails">
                {{sob.data && sob.data.running_sob_percentage}}%
              </div>
            </div>
          </li>
          <li class="mb-5" v-if="showSobAndFreightDetails">
            <label>{{$t('SOB_ESTIMATED')}}</label>
            <div class="list-content">
              <div v-if="showSobDetails">
                {{sob.data && sob.data.ideal_sob_percentage}}%
              </div>
            </div>
          </li>
        </ul>
        <div v-if="showTransporterSelection"
            class="collapse-slider-header mx-m15"
          :class="{'active': showTransporterSlider, 'is-disabled': (!this.$hasFeature('transporter_based_vehicles') && (!currentIndent.vehicleTypeId || checkOpenIndentForDropOffs)) || shuffleActive }">
            <div :class="{'event-disabler': !this.$hasFeature('transporter_based_vehicles') && (!currentIndent.vehicleTypeId || checkOpenIndentForDropOffs)}" style="width: 100%; display:flex;" @click="openTransporterSlider">
            {{$t('INDENT_TRANSPORTER').toUpperCase()}} - {{getTransporterSelectorText}}
                <svgicon
                  class="arrow-indicator"
                  :name="!showTransporterSlider ? 'icon-accordion-arrow-right' : 'icon-accordion-arrow-left'"
                  width="20"
                  height="20"
                  :original="true" />
          </div>
        </div>
        <ul
          class="drawer-list list-flex"
          v-if="showCompatibleVehicleDropdown || isLoadingCompatibleVehicles"
        >
          <li class="mb-5">
            <label>{{ $t('COMPATIBLE_VEHICLE') }}</label>
            <div class="list-content">
              <span v-if="isLoadingCompatibleVehicles" class="text-primary-sub">
                {{ $t('LOADING') }}...
              </span>
              <template v-else>
                <span
                  v-if="compatibleVehicleList.length === 0"
                  class="text-primary-sub"
                >
                  {{ $t('NOT_APPLICABLE') }}
                </span>
                <Select
                  v-else
                  v-model="selectedCompatibleVehicleId"
                  :placeholder="$t('SELECT_VEHICLE')"
                  size="mini"
                  class="select-default select-dark"
                  popper-class="select-dark-dropdown"
                  clearable
                  @change="onCompatibleVehicleChange"
                >
                  <Option
                    v-for="vehicle in compatibleVehicleList"
                    :key="vehicle.id"
                    :value="vehicle.id"
                    :label="vehicle.number"
                  />
                </Select>
              </template>
            </div>
          </li>
          <li class="mb-5" v-if="selectedVehicleMaterialType">
            <label>{{ $t('MDM_MATERIAL_TYPE') }}</label>
            <div class="list-content">
              <span class="text-primary">{{ selectedVehicleMaterialType }}</span>
            </div>
          </li>
        </ul>
        <Collapse v-model="activeNames" accordion class="collapse-slider collapse-dark mx-15">
          <CollapseItem  v-if="hasPurchaseOrderConfig && isPoOrderTypeEnabled"  title="More Info" :name="0">
          <div v-for="(field,index) in purchaseOrderFields"
            v-bind:key="index">
              <ul class="drawer-list list-flex">
                <li v-if="field.type=='dropdown'">
                  <label>{{field.label}}</label>
                  <div class="list-content">
                  <Select
                    :value="getPurchaseOrderValue(field.name)"
                    collapse-tags
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="data =>searchPurchaseOrder(data,field.name)"
                    align="right"
                    size="mini"
                    :placeholder="$t('SEARCH')"
                    popper-class="select-dark-dropdown text-right"
                    class="select-default select-dark"
                    :disabled="showTransporterSlider"
                      @input="changeIndentDetails($event, field.name)">
                    <Option
                      v-for="item in purchaseOrderFieldsListData[field.name]"
                      :key="item.id"
                      :label="item[field.name]"
                      :value="item">
                      </Option>
                    </Select>
                  </div>
                </li>
              </ul>
            </div>
          </CollapseItem>
        </Collapse>
      </div>
      </Col>
      <Col class="second-slider" v-if="showTransporterSlider">
      <div class="slider-body second-pane">
        <div class="d-flex pb-5">
              <Link :underline="false"
                   class="ml-auto" @click="closeTransporterSlider">
                <svgicon name="cancelwhite" width="12" height="12"/>
          </Link>
        </div>
        <ul class="drawer-list list-flex">
          <li class="mb-5">
                <label> {{$t('SELECT')}} {{ (currentIndent.rfq && currentType === 1) ? $t('TRANSPORTERS') : $t('INDENT_TRANSPORTER') }}</label>
            <div class="list-content" v-if="(currentIndent.rfq && currentType === 1) || (currentIndent.first_in_allotment && currentType === 0)">
                  <SwitchBtn
                    v-model="showSelected"
                    :active-text="$t('SHOW_SELECTED').toUpperCase()"
                    :inactive-text="$t('SHOW_SELECTED').toUpperCase()"
                    size="small"
                    class="default-switch switch-light text-capitalize"
                  >
              </SwitchBtn>
              ({{isAllTransportersSelected && totalTransporterCount > 0 ? totalTransporterCount - unselectedTransporters.length : checkedTransporters.length}})
            </div>
          </li>
          <li class="mb-10">
                <Input
                  :placeholder="$t('SEARCH')"
                  size="small"
                  class="input-dark"
                  v-model="searchedTransporters"
                  @input="filterTransporters"
                />
          </li>
        </ul>
        <div v-if="currentIndent.first_in_allotment && this.$hasFeature('first_in_allotment')" class="text-primary mb-10 px-10">
          <small>{{$t('Maximum 25 transporters can be selected')}}</small>
        </div>
            <Checkbox
              class="checkbox-dark text-bold text-capitalize mb-10"
              :value="isAllTransportersSelected"
              :indeterminate="isAllTransportersSelected && unselectedTransporters.length > 0"
              @change="toggleSelectAllTransporters"
              v-if="searchedTransporters === '' && currentIndent.rfq && currentType === 1 && !showSelected"
              >{{$t('SELECT_ALL')}}</Checkbox
            >
            <div class="scroll-custom" :style="getScrollStyle"
                @scroll="loadMore">
          <ul class="drawer-list list-flex" v-if="currentIndent.rfq && currentType === 1">
            <CheckboxGroup v-model="checkedTransporters" @change="updateSelectedTransporter">
                  <li
                    v-for="transporter in getTransporterList"
                    :key="transporter.id"
                    class="mb-1"
                  >
                    <Checkbox class="checkbox-dark" :label="transporter.id"
                    @change="(v) => updateSelection(v, transporter.id)"
                    >
                  <span class="text-primary position-relative text-lowercase">
                    {{transporter.name}}
                    <div class="text-primary-sub">{{transporter.location ? transporter.location : '&nbsp;'}}</div>
                  </span>
                </Checkbox>
              </li>
                  <li
                    v-if="
                     getTransporterList.length === 0
                    "
                  >
                {{$t('NO_DATA_AVAILABLE')}}
              </li>
            </CheckboxGroup>
          </ul>
          <ul class="drawer-list list-flex" v-else>
            <template v-if="isFirstAllotmentEligibleIndent" >
              <CheckboxGroup v-model="checkedTransporters" @change="updateSelectedTransporter">
                <Row :gutter="10" type="flex"
                :class="`list-card mx-0 mt-10 mb-10`"
                  v-for="transporter in getTransporterList"
                  :key="`contract-freight-${transporter.id}`"
                >
                  <Col class="px-10">
                    <Checkbox class="checkbox-dark mt-0" :label="transporter.id" @change="updateSelection" :disabled="checkedTransporters.length > 25 && !checkedTransporters.includes(transporter.id)">
                        <div :class="[{'lh-15': transporter.contracts.length === 1}, 'pb-5', 'mt-5', 'mb-2']"
                          class="d-flex justify-content-between align-items-center">
                          <span>{{ transporter.name }}</span>
                          <span v-if="$hasFeature('view_contract_at_shipment_creation') && $hasPermission('view_rate_matrix')"
                            class="px-0 popper-item-list lh-20">
                            <a :href="`/mdm/rate-matrix/${transporter.contract_id}`" target="_blank"
                              style="color: inherit; text-decoration: none;">
                              <svgicon name="external_link" class="icon" width="12" height="12" :original="true" />
                            </a>
                          </span>
                        </div>
                        <div v-if="transporter.contracts.length === 1" class="pb-5">
                          <Row :gutter="20" type="flex" class="mx-0">
                            <Col :span="22" class="px-0 popper-item-list lh-20">
                              <Ellipsis :text="`${transporter.contracts[0].source } - ${ transporter.contracts[0].destination}`" :length="37"/>
                              <small>{{transporter.contracts[0].transit_days}} {{transporter.contracts[0].transit_days > 1 ? $t('TMS_DAYS') : $t('TMS_DAY')}}</small>
                            </Col>
                            <Col :span="6" class="px-30 popper-item-list lh-20 justify-content-end">
                              <div class="text-right">
                                <strong v-if="!shouldHideContractPrices">
                                  <Ellipsis :text="`${currentClient.currency} ${transporter.contracts[0].rate.toFixed(2)}`" :length="10"/>
                                </strong>
                                <strong v-else>
                                  <svgicon name="Cost" width="13" height="13"/>
                                </strong>
                              </div>
                              <small v-if="!shouldHideContractPrices">{{contractFreightUnit[transporter.contracts[0].unit]}}</small>
                            </Col>
                          </Row>
                        </div>
                    </Checkbox>
                  </Col>
                  <Col :span="3" class="d-flex px-10" style="align-items: center;justify-content: end;" v-if="transporter.contracts.length > 1">
                    <Tooltip popper-class="popper-item wp-30" effect="dark" placement="bottom">
                      <div slot="content">
                        <h4 class="mb-0">{{ $t('COST_DETAILS') }}</h4>
                        <Row :gutter="20" type="flex" class="mx-0 py-10 popper-item-row"
                          v-for="(transporterContract, index) in transporter.contracts" :key="`additional-contracts-${index}`">
                          <Col :span="16" class="px-0 popper-item-list">
                            <Ellipsis :text="`${transporterContract.source} - ${transporterContract.destination}`" :length="60"/>
                            <small>{{transporterContract.transit_days}} {{transporterContract.transit_days > 1 ? $t('TMS_DAYS') : $t('TMS_DAY')}}</small>
                          </Col>
                          <Col :span="8" class="px-30 popper-item-list " style="display: grid;align-items: center;justify-content: end;">
                            <div class="text-right">
                              <strong v-if="!shouldHideContractPrices">
                                <Ellipsis :text="`${currentClient.currency} ${transporterContract.rate.toFixed(2)}`" :length="10"/>
                              </strong>
                              <strong v-else>
                                <svgicon name="Cost" width="13" height="13"/>
                              </strong>
                            </div>
                            <small v-if="!shouldHideContractPrices">{{contractFreightUnit[transporterContract.unit]}}</small>
                          </Col>
                        </Row>
                      </div>
                      <svgicon name="freight-universal-white" width="13" height="13" :original="true"/>
                    </Tooltip>
                  </Col>
                </Row>
              </CheckboxGroup>
            </template>
            <template v-else-if="canShowTransporterWithContractDetails">
              <Row :gutter="10" type="flex"
                :class="`${isSelectedTransporter(transporter) ? 'transporter-green-border' : ''} list-card mx-0 mt-10 mb-10`"
                v-for="transporter in getTransporterList"
                :key="`contract-freight-${transporter.id}`"
              >
                <Col class="px-10">
                  <div @click="selectContractedTransporter(transporter)">
                    <div :class="[{'lh-15': transporter.contracts.length === 1}, 'pb-5', 'mt-5', 'mb-2']"
                      class="d-flex justify-content-between align-items-center">
                      <span>{{ transporter.name }}</span>
                      <span v-if="$hasFeature('view_contract_at_shipment_creation') && $hasPermission('view_rate_matrix')"
                        class="px-0 popper-item-list lh-20">
                        <a :href="`/mdm/rate-matrix/${transporter.contract_id}`" target="_blank"
                          style="color: inherit; text-decoration: none;">
                          <svgicon name="external_link" class="icon" width="12" height="12" :original="true" />
                        </a>
                      </span>
                    </div>
                    <div v-if="transporter.contracts.length === 1" class="pb-5">
                      <Row :gutter="20" type="flex" class="mx-0">
                        <Col :span="16" class="px-0 popper-item-list lh-20">
                          <Ellipsis :text="`${transporter.contracts[0].source } - ${ transporter.contracts[0].destination}`" :length="37"/>
                          <small>{{transporter.contracts[0].transit_days}} {{transporter.contracts[0].transit_days > 1 ? $t('TMS_DAYS') : $t('TMS_DAY')}}</small>
                        </Col>
                        <Col :span="8" class="px-0 popper-item-list lh-20" style="display: grid;align-items: center;justify-content: end;">
                          <div class="text-right">
                            <strong v-if="!shouldHideContractPrices">
                              <Ellipsis :text="`${currentClient.currency} ${transporter.contracts[0].rate.toFixed(2)}`" :length="10"/>
                            </strong>
                            <strong v-else>
                              <svgicon name="Cost" width="13" height="13"/>
                            </strong>
                          </div>
                          <small v-if="!shouldHideContractPrices">{{contractFreightUnit[transporter.contracts[0].unit]}}</small>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col :span="3" class="d-flex px-10" style="align-items: center;justify-content: end;" v-if="transporter.contracts.length > 1">
                  <Tooltip popper-class="popper-item wp-30" effect="dark" placement="bottom">
                    <div slot="content">
                      <h4 class="mb-0">{{ $t('COST_DETAILS') }}</h4>
                      <Row :gutter="20" type="flex" class="mx-0 py-10 popper-item-row"
                        v-for="(transporterContract, index) in transporter.contracts" :key="`additional-contracts-${index}`">
                        <Col :span="16" class="px-0 popper-item-list">
                          <Ellipsis :text="`${transporterContract.source} - ${transporterContract.destination}`" :length="60"/>
                          <small>{{transporterContract.transit_days}} {{transporterContract.transit_days > 1 ? $t('TMS_DAYS') : $t('TMS_DAY')}}</small>
                        </Col>
                        <Col :span="8" class="px-0 popper-item-list" style="display: grid;align-items: center;justify-content: end;">
                          <div class="text-right">
                            <strong v-if="!shouldHideContractPrices">
                              <Ellipsis :text="`${currentClient.currency} ${transporterContract.rate.toFixed(2)}`" :length="10"/>
                            </strong>
                            <strong v-else>
                              <svgicon name="Cost" width="13" height="13"/>
                            </strong>
                          </div>
                          <small v-if="!shouldHideContractPrices">{{contractFreightUnit[transporterContract.unit]}}</small>
                        </Col>
                      </Row>
                    </div>
                    <svgicon name="freight-universal-white" width="13" height="13" :original="true"/>
                  </Tooltip>
                </Col>
              </Row>
            </template>
            <RadioGroup v-else v-model="selectedTransporterContractKey" style="width: 100%;"
            >
                  <li
                    v-for="transporter in getTransporterList"
                    :key="transporter.id"
                    class="mb-1"
                  >
                  <div class="d-flex align-items-center justify-content-between"
                  style="width: 100%;">
                  <Radio
                    class="radio-dark"
                    :label="getLabel(transporter)"
                    @click.native="updateTransporterForRadioButton(transporter)"
                  >
                    <span class="text-primary position-relative text-lowercase">
                      {{ transporter.name }}
                      <div class="text-primary-sub pl-25">{{ transporter.location }}</div>
                    </span>
                  </Radio>
                  <span
                    v-if=" currentType === 0 && $hasPermission('view_rate_matrix') && $hasFeature('view_contract_at_shipment_creation')"
                    class="ml-auto">
                    <a :href="`/mdm/rate-matrix/${transporter.contract_id}`" target="_blank"
                      style="color: inherit; text-decoration: none;">
                      <svgicon name="external_link" class="icon" width="12" height="12" :original="true" />
                    </a>
                  </span>
                </div>
              </li>
            </RadioGroup>
            <li v-if="!transportersList.length && !checkedTransporters.length || (searchedTransporters !== '' && !transportersList.length)">
              {{ $t('NO_DATA_AVAILABLE') }}
            </li>
          </ul>
        </div>
      </div>
      </Col>
      <Col class="second-slider" v-if="shuffleActive">
      <div class="slider-body second-pane">
        <div class="d-flex pb-5">
                <Link :underline="false"
                     class="ml-auto" @click="openShufflePane">
                  <svgicon name="cancelwhite" width="12" height="12"/>
          </Link>
        </div>
        <p class="text-capitalize shuffle-header">{{$t('INDENT_DRAG_DROP_TO_CHANGE_SEQUENCE')}}</p>
        <div class="mt-25" style="height: calc(100% - 100px);">
              <pickup-drop-timeline :draggable="true" :pickupDrops="getPickupDrops" :resetSequence="resetSequence" @set-initial-sequence="setSequence" :isOutbound="isOutbound" ref="pickupDropTimeline"
              @update-sequence="updateSequence"/>
        </div>
      </div>
      </Col>
    </Row>
    <div class="slider-footer footer-dark">
      <div class="flex-container">
        <div class="flex-item" v-if="transitDays">
          <span class="number text-green">{{transitDays}}</span>
          {{$t('INDENT_TRANSIT_DAYS')}}
        </div>
        <div class="flex-item ml-auto" v-if="count">
          <span class="number text-green">{{count}}</span>
          {{$t('INDENT_TOTAL_PICKUPS')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from 'debounce';
import { flatten, uniqBy } from 'lodash';
import { mapGetters } from 'vuex';
import FilterMultipleDropdown from '@common/components/FilterMultipleDropdown';

import { freightTypeList, deliveryTypes, numberOfVehicles } from '@/modules-v2/indent/constants/order';
import contractConstants from '@/constants/contract';
import { isOpen, isMarket, isNoFreight, isContract } from '@common/lib/order';

import AppConstant from '@/constants/app';
import { OpenIndentcontractTypes as contractTypes, deliveryName } from '@/constants/order';
import { sourceAndDestinationType, movementType, VolumeUnits, IndentTransferType } from 'pando-constants';
import FreightTypeForFtlPtl from '@/components/mixins/FreightType.vue';
import ContractCheck from '@/modules-v2/indent/mixins/create-update/contract-check';
import PickupDropTimeline from './PickupDropTimeline';
import VolumeFormulaConvertor from '../../../../../../common-v2/helpers/volume-formula-converter';

export default {
  components: {
    FilterMultipleDropdown,
    PickupDropTimeline,
  },
  props: {
    sourceConfig: {
      default: () => ([]),
      type: Array,
    },
    vehicles: {
      default: () => ([]),
      type: Array,
    },
    currentIndent: {
      default: () => ({}),
      type: Object,
    },
    disableIndentButton: {
      default: false,
      type: Boolean,
    },
    count: {
      default: 0,
      type: Number,
    },
    showMasterData: {
      default: false,
      type: Boolean,
    },
    hasOpenRfqIndentConfig: {
      default: false,
      type: Boolean,
    },
    transitDays: {
      default: 0,
      type: [Number, Boolean],
    },
    isOnlyChangeTruckState: {
      default: false,
      type: Boolean,
    },
    isCreateFromDraftState: {
      default: false,
      type: Boolean,
    },
    hideAllActions: {
      default: false,
      type: Boolean,
    },
    isEximIndent: {
      default: false,
      type: Boolean,
    },
    isEditState: {
      default: false,
      type: Boolean,
    },
    isFromEximListing: {
      default: false,
      type: Boolean,
    },
    // purchase order props
    hasPurchaseOrderConfig: {
      default: false,
      type: Boolean,
    },
    purchaseOrderFields: {
      default: () => ([]),
      type: Array,
    },
    purchaseOrderFieldsListData: {
      default: () => ({}),
      type: Object,
    },
    isPoOrderTypeEnabled: {
      default: false,
      type: Boolean,
    },
    showIndentPrompt: {
      type: Boolean,
      default: false,
    },
    showIndentPromptDropLimit: {
      type: Boolean,
      default: false,
    },
    IndentPromptLimit: {
      type: Number,
      default: 0,
    },
    sourcesDropOffs: {
      type: Array,
      default: () => ([]),
    },
    selectedType: {
      type: String,
      default: () => -1,
    },
    selectedTransporterName: {
      type: String,
      default: '',
    },
    currentActiveSourceIndex: {
      type: Number,
      default: 0,
    },
    isOutbound: {
      type: Boolean,
      default: true,
    },
    isFromCloneState: {
      type: Boolean,
      default: false,
    },
    selectedContracts: {
      type: Array,
      default: () => [],
    },
    isFromOptima: {
      type: Boolean,
      default: false,
    },
    totalMaterialWeight: {
      type: Number,
      default: 0,
    },
    totalMaterialVolume: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedContractIds: [],
      contractFreightUnit: contractConstants.freightUnit,
      textarea: '',
      freightTypeList,
      activeNames: 0,
      contractTypes,
      transporterSelectAll: false,
      showTransporterSlider: false,
      checkedTransporters: [], // Contains ids of checked transporters
      selectedTransporter: null, // Controls radio button single transporter selection
      isAllTransportersSelected: false, // Controls select all action for checkboxes
      totalTransporterCount: 0, // Total count across all pages when select all is active
      unselectedTransporters: [], // Tracks deselected transporter IDs when in all-selected mode
      searchedTransporters: '',
      compatibleVehicleList: [],
      selectedCompatibleVehicleId: null,
      isLoadingCompatibleVehicles: false,
      searchActive: false,
      showSelected: false,
      disableLoader: false,
      loadCheck: false, // To monitor loading
      shuffleActive: false,
      resetSequence: true,
      shuffledList: [],
      sequenceData: null,
      considerReturnFreightRate: false,
      sob: {
        data: {
          ideal_sob_percentage: 0,
          running_sob_percentage: 0,
          freight_rate: '',
          freight_unit: '',
        },
      },
      selectedTransporterContractKey: '',
      storedSelectedTransporters: []
    };
  },
  mixins: [FreightTypeForFtlPtl, ContractCheck],
  watch: {
    sourcesDropOffs: {
      handler() {
        this.resetSequence = true;
        this.shuffledList = [];
      },
      deep: true,
    },
    currentIndent: {
      handler(newVal) {
        if (newVal && newVal.vehicleTypeId) {
          this.getSobDetails(newVal.vehicleTypeId);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      masterVehiclesList: 'indentV2/masterVehiclesList', // all vehicle types list
      masterTransportersList: 'mdm/all',
      noFreightTransportersList: 'indentV2/masterTransportersList', // all transporter list
      isOrderProcessing: 'indentV2/isOrderProcessing',
      configurations: 'app/configurations',
      currentClient: 'app/currentClient',
    }),
    preferredVolumeUnit() {
      return this.$preferredVolumeUnit();
    },
    canShowTransporterWithContractDetails() {
      return !this.$hasFeature('override_order_type') && this.isContractIndent && this.$hasPermission('view_contract_indent_base_freight');
    },
    isFirstAllotmentEligibleIndent() {
      return !this.$hasFeature('override_order_type')
        && this.currentIndent.first_in_allotment
        && this.isContractIndent
        && this.$hasFeature('first_in_allotment');
    },
    restrictQueryEnhancerEnabled() {
      return this.$hasFeature('resist_query_enhancer');
    },
    getColStyle() {
      if (this.transitDays || this.count) {
        return {
          width: '350px',
        };
      }
      return {
        width: '350px',
        height: 'calc(100vh - 105px)',
        'overflow-y': 'auto',
      };
    },
    getScrollStyle() {
      return (this.currentIndent.rfq && this.currentType === 1 && !this.searchActive && !this.showSelected) ? { height: 'calc(100% - 114px)', overflow: 'auto' }
        : { height: 'calc(100% - 85px)', overflow: 'auto' };
    },
    freightTypeName() {
      const freightType = this.freightTypeList &&
        this.freightTypeList.find(freightType => freightType.id === this.currentIndent.freightType);
      return freightType && freightType.label;
    },
    isNoFreightDefaultValues() {
      return Boolean(
        this.configurations.indentConfig &&
          this.configurations.indentConfig.no_freight_default_transporter &&
          this.configurations.indentConfig.no_freight_default_vehicle_type,
      );
    },
    isMultiDropPtlRestricted() {
      return this.currentIndent.deliveryType === 'PTL' &&
        this.$hasFeature('restrict_multi_drop_for_ptl');
    },
    isOpenIndent() {
      return this.currentIndent && isOpen(this.currentIndent.type.name);
    },
    transferTypeOptions() {
      return [
        { id: IndentTransferType.REGULAR, name: this.$t('TRANSFER_TYPE_REGULAR') },
        { id: IndentTransferType.OUT_OF_METRICS, name: this.$t('TRANSFER_TYPE_OUT_OF_METRICS') },
        { id: IndentTransferType.DC_TO_DC, name: this.$t('TRANSFER_TYPE_DC_TO_DC') },
        { id: IndentTransferType.DESTRUCTION, name: this.$t('TRANSFER_TYPE_DESTRUCTION') },
      ];
    },
    isNoFreightIndent() {
      return this.currentIndent && isNoFreight(this.currentIndent.type.name);
    },
    isMarketIndent() {
      return this.currentIndent && isMarket(this.currentIndent.type.name);
    },
    isContractIndent() {
      return this.currentIndent && isContract(this.currentIndent.type.name);
    },
    showCompatibleVehicleDropdown() {
      const isTransporterSelected = !!this.selectedTransporter
        || !!this.currentIndent.transporterId
        || this.checkedTransporters.length > 0;
      return this.isContractIndent
        && this.$hasFeature('vehicle_destination_depot_mapping')
        && this.configurations && this.configurations.override_type_with_vehicle
        && isTransporterSelected
        && !!this.currentIndent.vehicleTypeId;
    },
    selectedVehicleMaterialType() {
      if (!this.selectedCompatibleVehicleId) return null;
      const vehicle = this.compatibleVehicleList.find(v => v.id === this.selectedCompatibleVehicleId);
      return vehicle && vehicle.material_type ? vehicle.material_type : null;
    },
    getTransporterSelectorText() {
      if (this.isContractIndent) {
        if (this.currentIndent.first_in_allotment && this.checkedTransporters.length) {
          return `${this.checkedTransporters.length} ${this.$t('SELECTED')}`;
        }
        return this.selectedTransporterName ? this.selectedTransporterName : this.$t('SELECT_CONTRACTED_TRANSPORTER');
      }
      if (this.currentIndent.rfq && this.currentType === 1) {
        if (this.checkedTransporters.length) {
          const count = this.isAllTransportersSelected && this.totalTransporterCount > 0
            ? this.totalTransporterCount - this.unselectedTransporters.length
            : this.checkedTransporters.length;
          return `${count} ${this.$t('SELECTED')}`;
        }
        return `${this.$t('PICK_AT_LEAST')} 2`;
      }
      return this.selectedTransporterName ? this.selectedTransporterName : this.$t('SELECT_TRANSPORTER');
    },
    currentSelectPurchaseOrder() {
      return this.currentIndent && this.currentIndent.purchaseOrderId
        ? this.currentIndent.purchaseOrderId : '';
    },
    deliveryTypeList() {
      return this.getDeliveryTypeList();
    },
    vehicleTypesList() {
      return this.getVehicleTypesList();
    },
    noOfVehicles() {
      if (this.currentIndent.shipment_number) {
        return 1;
      }
      return (this.currentIndent && this.currentIndent.no_of_vehicles) || 1;
    },
    numberOfVehiclesList() {
      if (this.currentIndent && this.currentIndent.shipment_number) {
        return 1;
      }
      const start = numberOfVehicles.min;
      const end = numberOfVehicles.max;
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },
    transportersList() {
      const isClientSideFilter = this.currentType === 2 || (this.currentType === 0 && !this.$hasFeature('override_order_type'));
      if (isClientSideFilter && this.searchedTransporters) {
        const searchValue = this.searchedTransporters.toLowerCase();
        let filteredTransporters = [];
        if (this.getTransportersList() && this.getTransportersList().length) {
          filteredTransporters = this.getTransportersList().filter((_transporter) => {
            const transporterName = this.currentType === 0 ? _transporter.transporter_name : _transporter.name; // contract case check
            return (transporterName.toLowerCase().includes(searchValue)
          || (_transporter.reference_id && _transporter.reference_id.toLowerCase().includes(searchValue)));
          });
        }
        return filteredTransporters.map(transporter => ({
          id: transporter.id,
          name: this.currentType === 0 ? transporter.transporter_name : transporter.name, // contract case check
          location: (transporter.city && transporter.reference_id) ? `${transporter.city} - ${transporter.reference_id}` : '',
          contracts: transporter.additional_contracts,
          contract_id: transporter.contract_id,
          isNoFreight: transporter.isNoFreight,
        }));
      }
      return (this.getTransportersList() || []).map(transporter => ({
        id: transporter.id,
        name: this.currentType === 0 && !this.$hasFeature('override_order_type') ? transporter.transporter_name : transporter.name,
        location: (transporter.city && transporter.reference_id) ? `${transporter.city} - ${transporter.reference_id}` : '',
        contracts: transporter.additional_contracts || [],
        contract_id: transporter.contract_id,
        isNoFreight: transporter.isNoFreight,
      }));
    },
    currentType() {
      return this.currentIndent.type.id;
    },
    getTooltipTitle() {
      if (this.disableIndentButton) {
        return `${this.$t('PICK_AT_LEAST')} 2 ${this.$t('INDENT_TRANSPORTERS').toLowerCase()}`;
      }
      return '';
    },
    /**
     * To disable transporter slider open
     * @return "{ true - When no sources are present/ if a pickup doesnt have any drop }"
     * "{ false - If its a contract indent }"
     */
    checkOpenIndentForDropOffs() {
      if (this.isContractIndent) return false;
      const sourcesCount = this.sourcesDropOffs.length;
      if (!sourcesCount) return true;
      let flagCheck = true;
      for (let itr = 0; itr < sourcesCount; itr += 1) {
        if (this.sourcesDropOffs[itr].pickups.length) {
          const dropsPresentForAllPickups = this.sourcesDropOffs[itr].pickups
            .every(_pickup => (_pickup.dropoffs && _pickup.dropoffs.length));
          flagCheck = !dropsPresentForAllPickups;
          if (flagCheck) { // To exit from loop if atleast one pickup is present without drops
            break;
          }
        }
      }
      return flagCheck;
    },
    /**
     * To construct data for timeline
     */
    // !Critical computed property that decides the timeline data, its display sequence etc.
    getPickupDrops() {
      if (this.resetSequence) { //* Goes in everytime when the source/dropoffs are added
        if (!this.sourcesDropOffs.length) return [];
        let allEntries = []; //* Accumulate the final sequential/non-sequential list.
        const dropOffEntries = []; //* To keep the list of drops added sequentially.
        const pickupEntries = []; //* temporary accumulator of entries that has sequence number.
        const nonSequentialPickupDrops = []; //* To main the list of pickups and drops that doesn't have sequence number.
        let pickupDrops = []; //* final accumulator of entries that has sequence number.
        for (let currentActiveSourceIndex = 0; currentActiveSourceIndex < this.sourcesDropOffs.length; currentActiveSourceIndex += 1) {
          if (this.sourcesDropOffs[currentActiveSourceIndex].pickups.length) {
            if (parseInt(this.sourcesDropOffs[currentActiveSourceIndex].type, 10) === sourceAndDestinationType.CONSIGNEE) {
              const seqNo = this.sourcesDropOffs[currentActiveSourceIndex].pickups[0].sequence_number;
              if (seqNo) {
                pickupEntries.push({ name: this.sourcesDropOffs[currentActiveSourceIndex].name, type: 'pickup', ref_id: this.sourcesDropOffs[currentActiveSourceIndex].reference_id, sequence: seqNo, isConsignee: true });
              } else {
                nonSequentialPickupDrops.push({ name: this.sourcesDropOffs[currentActiveSourceIndex].name, type: 'pickup', ref_id: this.sourcesDropOffs[currentActiveSourceIndex].reference_id, sequence: null, isConsignee: true });
              }
            }
            const pickupDropEntries = this.sourcesDropOffs[currentActiveSourceIndex].pickups.reduce((_acc, pickup) => {
              let result = _acc;
              if (pickup.name) {
                const sequence = pickup.sequence_number || null;
                if (sequence) {
                  result.push({ name: pickup.name, type: 'pickup', ref_id: pickup.reference_id, sequence });
                  pickupEntries.push({ name: pickup.name, type: 'pickup', ref_id: pickup.reference_id, sequence });
                } else {
                  nonSequentialPickupDrops.push({ name: pickup.name, type: 'pickup', ref_id: pickup.reference_id, sequence });
                }
              }
              const { dropOffs, noSeqDrops } = pickup.dropoffs ? pickup.dropoffs.reduce((_subAcc, drop) => {
                const sequence = drop.ship_to.sequence_number || null;
                if (sequence) {
                  _subAcc.dropOffs.push({ name: drop.ship_to.name, type: 'drop', ref_id: drop.ship_to.reference_id, sequence });
                } else {
                  _subAcc.noSeqDrops.push({ name: drop.ship_to.name, type: 'drop', ref_id: drop.ship_to.reference_id, sequence });
                }
                return _subAcc;
              }, { dropOffs: [], noSeqDrops: [] }) : { dropOffs: [], noSeqDrops: [] };
              dropOffEntries.push(...dropOffs);
              nonSequentialPickupDrops.push(...noSeqDrops);
              result = [...result, ...dropOffs];
              return result;
            }, []);
            pickupDrops = [...pickupDrops, ...pickupDropEntries];
          }
        }
        if (this.lastMileEnabled) {
          if (this.isEditState || this.isFromCloneState) {
            allEntries = [...pickupEntries, ...dropOffEntries];
            const allEntriesSize = allEntries.length;
            allEntries = (allEntriesSize && allEntries[0].sequence) ? allEntries.sort((a, b) => a.sequence - b.sequence) : allEntries;
            const endSeq = (allEntriesSize && allEntries[0].sequence) ? allEntries[allEntriesSize - 1].sequence : 1;
            if (endSeq && nonSequentialPickupDrops.length) {
              const sequencedEntries = nonSequentialPickupDrops.map((_item, idx) => ({ ..._item, sequence: endSeq + idx }));
              allEntries = [...allEntries, ...sequencedEntries];
            }
          } else { // During creation
            const { pickups, drops } = nonSequentialPickupDrops.reduce((_acc, entry) => {
              if (entry.type === 'pickup') {
                _acc.pickups.push(entry);
              } else {
                _acc.drops.push(entry);
              }
              return _acc;
            }, { pickups: [], drops: [] });
            allEntries = [...pickupEntries, ...pickups, ...dropOffEntries, ...drops];
          }
        } else if (this.isEditState || this.isFromCloneState) {
          allEntries = [...allEntries, ...pickupDrops];
          const allEntriesSize = allEntries.length;
          allEntries = (allEntriesSize && allEntries[0].sequence) ? allEntries.sort((a, b) => a.sequence - b.sequence) : allEntries;
          allEntries = [...allEntries, ...nonSequentialPickupDrops];
        } else if (this.isCreateFromDraftState) {
          const { pickups, drops } = nonSequentialPickupDrops.reduce((_acc, entry) => {
            if (entry.type === 'pickup') {
              _acc.pickups.push(entry);
            } else {
              _acc.drops.push(entry);
            }
            return _acc;
          }, { pickups: [], drops: [] });
          allEntries = [...pickupEntries, ...pickups, ...dropOffEntries, ...drops];
        } else {
          allEntries = [...allEntries, ...nonSequentialPickupDrops];
        }
        return allEntries;
      }
      //* Executes when reordering happens
      return this.shuffledList;
    },
    /**
     * Returns the updated transporters list
     */
    getTransporterList() {
      if (this.showSelected) {
        if (this.isNoFreightIndent) {
          return this.transportersList.filter(transporter => transporter.isNoFreight);
        }
        // If searching, only show selected transporters from current search results
        if (this.searchedTransporters) {
          return this.transportersList.filter(_transporter => 
            this.checkedTransporters.includes(_transporter.id)
          );
        }
        // If not searching, show all selected transporters (current + stored)
        const selectedFromCurrentList = this.transportersList.filter(_transporter => 
          this.checkedTransporters.includes(_transporter.id)
        );
        const allSelected = [...selectedFromCurrentList];
        if (this.storedSelectedTransporters) {
          this.storedSelectedTransporters.forEach(stored => {
            if (this.checkedTransporters.includes(stored.id) && 
                !allSelected.find(t => t.id === stored.id)) {
              allSelected.push(stored);
            }
          });
        }
        return allSelected;
      }
      if (this.isNoFreightIndent) {
        return this.transportersList.filter(transporter => transporter.isNoFreight)
      }
      return this.transportersList;
    },
    showTransporterSelection() {
      return !(this.isMarketIndent || this.isOnlyChangeTruckState || this.hideAllActions);
    },
    lastMileEnabled() {
      return this.$hasFeature('last_mile');
    },
    checkMovementAndType() {
      return this.sourcesDropOffs && this.sourcesDropOffs[0] && this.sourcesDropOffs[0].type &&
        this.sourcesDropOffs[0].type.toString() !== movementType.INWARD.toString() && this.currentType === 0;
    },
    showSobAndFreightDetails() {
      return this.$hasFeature('show_sob_utilization_details') && !this.currentIndent.type.id &&
        this.$hasPermission('show_running_ideal_sob') && !this.currentIndent.first_in_allotment;
    },
    showSobDetails() {
      return this.currentIndent.transporterId;
    },
    showFirstInAllotment() {
      return this.$hasFeature('first_in_allotment') && this.sourcesDropOffs && this.sourcesDropOffs[0] && this.sourcesDropOffs[0].type && this.isContractIndent;
    },
    considerReturnFreightChargeEnabled() {
      return this.$hasFeature('consider_return_freight_charge');
    },
    showBulkPTLIndentToggle() {
      return this.$hasFeature('optima_bulk_ptl_indents') && this.isFromOptima && this.currentIndent.deliveryType === 'PTL';
    },
    shouldHideContractPrices() {
      return this.$hasPermission('hide_contract_prices');
    },
    weightUtilisation() {
      if (this.currentIndent.deliveryType === 'PTL') {
        return 100;
      }

      let materialWeight = 0;
      materialWeight = this.totalMaterialWeight || 0;

      const selectedVehicle = this.vehicleTypesList.find(vehicle => vehicle.id === this.currentIndent.vehicleTypeId);
      const vehicleWeight = selectedVehicle ? selectedVehicle.weight || selectedVehicle.kg || 0 : 0;

      if (vehicleWeight === 0) return 0;
      return Math.round((materialWeight / vehicleWeight) * 100);
    },
    volumeUtilisation() {
      if (this.currentIndent.deliveryType === 'PTL') {
        return 100;
      }

      let materialVolume = 0;


      materialVolume = this.totalMaterialVolume || 0;

      const selectedVehicle = this.vehicleTypesList.find(vehicle => vehicle.id === this.currentIndent.vehicleTypeId);
      const vehicleVolume = selectedVehicle ? selectedVehicle.volume || selectedVehicle.cft || 0 : 0;

      if (vehicleVolume === 0) return 0;
      return Math.round((materialVolume / vehicleVolume) * 100);
    },
  },
  methods: {
    updateTransporterForRadioButton(transporter) {
      this.selectedTransporter = transporter.id;
      this.selectedTransporterContractKey = transporter.id;
      if (this.restrictQueryEnhancerEnabled && transporter.contract_id) {
        this.selectedTransporterContractKey = `${transporter.id}_${transporter.contract_id}`;
      }
      if (this.isContractIndent) {
        this.selectContractedTransporter(transporter);
      } else {
        this.updateSelectedTransporter(transporter.id);
      }
    },
    selectContractedTransporter(transporter) {
      this.selectedTransporter = transporter.id;
      if (this.restrictQueryEnhancerEnabled) {
        this.selectedContractIds = [];
        if (transporter.contracts) {
          transporter.contracts.forEach((contract) => {
            this.selectedContractIds.push(contract.contract_id);
          });
        } else {
          this.selectedContractIds.push(transporter.contract_id);
        }
      }
      this.updateSelectedTransporter(transporter.id, transporter.contract_id);
      this.clearCompatibleVehicle();
      this.fetchCompatibleVehicles();
    },
    async updateSequence(list) {
      this.resetSequence = false;
      this.shuffledList = list;
      const flattedPickupDrops = this.getFlattenedData();
      const payload = this.constructCheckPayload(flattedPickupDrops, list);
      if (payload) {
        this.$emit('update-sequence-data', this.sequenceData);
        this.$refs.pickupDropTimeline.syncPreviousList();
      }
    },
    async fetchCompatibleVehicles() {
      const hasTransporter = !!this.selectedTransporter || !!this.currentIndent.transporterId;
      const hasVehicleType = !!this.currentIndent.vehicleTypeId;
      const isFeatureOn = this.$hasFeature('vehicle_destination_depot_mapping')
        && this.configurations && this.configurations.override_type_with_vehicle;
      if (!this.isContractIndent || !isFeatureOn || !hasTransporter || !hasVehicleType) return;
      const routes = this.getSourcesWithDestinations();
      if (!routes.length) return;
      this.isLoadingCompatibleVehicles = true;
      try {
        const result = await this.$store.dispatch('order/getCompatibleVehicles', {
          params: {
            vehicle_type: this.currentIndent.vehicleTypeId,
            transporter_id: this.selectedTransporter || this.currentIndent.transporterId,
            ...(this.currentIndent.vehicle_details_id ? { current_vehicle_id: this.currentIndent.vehicle_details_id } : {}),
          },
          routes: routes.map(({ sourceDepotId, destinationDepotIds }) => ({
            source: sourceDepotId,
            destinations: destinationDepotIds,
          })),
        });
        this.compatibleVehicleList = (result && result.data) || [];
        const savedVehicleId = this.currentIndent.vehicle_details_id;
        const savedVehicleNumber = this.currentIndent.vehicle_number;
        if (savedVehicleId && !this.selectedCompatibleVehicleId) {
          const match = this.compatibleVehicleList.find(
            v => v.id === savedVehicleId || v.id.toString() === savedVehicleId.toString()
              || (savedVehicleNumber && v.number.replace(/\s+/g, '') === savedVehicleNumber.replace(/\s+/g, '')),
          );
          if (match) this.selectedCompatibleVehicleId = match.id;
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      } finally {
        this.isLoadingCompatibleVehicles = false;
      }
    },
    getSourcesWithDestinations() {
      const result = [];
      this.sourcesDropOffs.forEach((source) => {
        if (!source.id) return;
        (source.pickups || []).forEach((pickup) => {
          const destIds = new Set();
          (pickup.dropoffs || []).forEach((drop) => {
            const depotId = drop.ship_to && (drop.ship_to.location_id || drop.ship_to.id);
            if (depotId) destIds.add(depotId);
          });
          if (destIds.size) {
            result.push({ sourceDepotId: source.id, destinationDepotIds: [...destIds] });
          }
        });
      });
      const seen = new Set();
      return result.filter(({ sourceDepotId, destinationDepotIds }) => {
        const key = `${sourceDepotId}:${[...destinationDepotIds].sort().join(',')}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    clearCompatibleVehicle() {
      this.compatibleVehicleList = [];
      this.selectedCompatibleVehicleId = null;
    },
    onCompatibleVehicleChange(vehicleId) {
      const vehicle = this.compatibleVehicleList.find(v => v.id === vehicleId);
      this.$emit('changeIndentDetails', {
        ...this.currentIndent,
        vehicle_details_id: vehicleId || null,
        vehicle_number: vehicle ? vehicle.number.replace(/\s+/g, '') : null,
        vehicle_material_type: vehicle ? vehicle.material_type || null : null,
      });
    },
    getNoOfVehicles(item) {
      if (this.currentIndent.shipment_number) {
        return 1;
      }
      return item;
    },
    openFreightType(OpenFreightTypeId) {
      return this.contractTypes.find(type => type.id === OpenFreightTypeId).name || '-';
    },
    transferTypeLabel(id) {
      const found = this.transferTypeOptions.find(o => o.id === id);
      return found ? found.name : '\u2014';
    },
    getDeliveryTypeList(freightTypeInput = null) {
      const freightType = freightTypeInput || this.currentIndent.freightType;
      let vehicleTypesList = [];
      if (this.isNoFreightIndent && this.isNoFreightDefaultValues && freightType === AppConstant.FreightType.PARTY_COLLECT) {
        vehicleTypesList = this.masterVehiclesList.filter(val => val.id === this.configurations.indentConfig
          .no_freight_default_vehicle_type);
      } else {
        vehicleTypesList = this.showMasterData ? this.masterVehiclesList : this.vehicles;
      }
      return deliveryTypes && deliveryTypes.filter(type => vehicleTypesList.some(val => val.type === type.id));
    },
    getVehicleTypesList(transporterIdInput = null, deliveryTypeInput = null, freightTypeInput = null) {
      const freightType = freightTypeInput || this.currentIndent.freightType;
      if (this.isNoFreightIndent && this.configurations.indentConfig
        .no_freight_default_vehicle_type && freightType === AppConstant.FreightType.PARTY_COLLECT) {
        const vehicle = this.masterVehiclesList.filter(val => val.id === this.configurations.indentConfig
          .no_freight_default_vehicle_type);
        return vehicle;
      }
      const transporterId = transporterIdInput || this.currentIndent.transporterId;
      const deliveryType = deliveryTypeInput || this.currentIndent.deliveryType;
      const list = this.showMasterData ? this.masterVehiclesList : this.vehicles;
      if ((this.isOnlyChangeTruckState || this.$hasFeature('transporter_based_vehicles')) && !this.showMasterData) {
        return list.filter(val => val.transporters.some(val => val.id === transporterId) &&
            val.type === deliveryType);
      }
      const value = list.filter(val =>
        val.type === deliveryType);
      return value;
    },
    getTransportersList(vehicleTypeIdInput = null, freightTypeInput = null, deliveryTypeInput = null) {
      const freightType = freightTypeInput || this.currentIndent.freightType;
      this.selectedContractIds = []
        .concat(this.selectedContractIds || [])
        .concat((this.currentIndent && this.currentIndent.selected_contracts) || []);
      this.currentIndent.selected_contracts = [];
      if (this.isNoFreightIndent && this.configurations.indentConfig
        .no_freight_default_transporter && freightType === AppConstant.FreightType.PARTY_COLLECT) {
        const transporter = (this.noFreightTransportersList && this.noFreightTransportersList.filter(val => val.id === this.configurations.indentConfig
          .no_freight_default_transporter)) || [];
        return transporter;
      }
      const vehicleTypeId = vehicleTypeIdInput || this.currentIndent.vehicleTypeId;
      if (this.showMasterData) {
        return this.isNoFreightIndent ? this.noFreightTransportersList : this.masterTransportersList || [];
      }
      if (this.$hasFeature('transporter_based_vehicles')) {
        const deliveryType = deliveryTypeInput || this.currentIndent.deliveryType;
        return uniqBy(flatten(this.vehicles.filter(val => val.type === deliveryType)
          .map(val => val.transporters)), 'id');
      }
      const vehicle = this.currentIndent && this.vehicles.find(val =>
        val.id === vehicleTypeId);
      return (vehicle && vehicle.transporters) || [];
    },
    createIndent(canCreateIndent, inDraftStatus = false) {
      if (canCreateIndent && !this.isOrderProcessing) {
        this.$emit('createIndent', { inDraftStatus, contractId: this.selectedContractIds });
      }
    },
    disableIndentPromptDropLimit() {
      this.$emit('disableIndentPromptDropLimit', false);
    },
    routeToIndent() {
      const type = this.$route.params.type;
      if (this.isEximIndent && this.isFromEximListing) {
        this.$router.push({ name: 'EximMasterIndent' });
      } else if (parseInt(type, 10) === 1) {
        this.$router.push({ name: 'InboundIndentsV2' });
      } else if (parseInt(type, 10) === 0) {
        this.$router.push({ name: 'OutboundIndentsV2' });
      } else if (parseInt(type, 10) === 2) {
        if (this.$route.params.allDepot) {
          this.$router.push({ name: 'Optima All Depot' });
        } else {
          this.$router.push({ name: 'Optima Input' });
        }
      }
    },
    async changeIndentDetails($event, key) {
      let data = { ...this.currentIndent };
      data[key] = $event;
      if (key === 'shipment_number' && $event) {
        data.no_of_vehicles = 1;
      }
      if (key === 'deliveryType') {
        data = this.getDeliveryTypeDependentData(data);
        if (this.isOpenIndent) {
          data.open_freight_type = (this.freightTypeForFtlPtl(data.deliveryType)).id;
        }
      }
      if (key === 'vehicleTypeId' && !this.isOnlyChangeTruckState && !this.$hasFeature('transporter_based_vehicles')) {
        data = this.getUpdatedTransporterId(data);
        this.selectedTransporter = data.transporterId || null;
      }
      if (key === 'vehicleTypeId') {
        this.clearCompatibleVehicle();
        if (data.transporterId) this.fetchCompatibleVehicles();
      }
      if (key === 'transporterId') {
        this.clearCompatibleVehicle();
      }
      if (key === 'rfq') {
        data.transporterId = ($event === false) ? null : [];
      }
      // purchase order checks
      if (key === 'po_number') { // if po number is changed set acc , line to null
        data.account_assignment_number = null;
        data.po_line_number = null;
        data.purchaseOrderId = data[key].id;
      }
      if (key === 'account_assignment_number') {
        data.po_line_number = null;
        data.purchaseOrderId = data[key].id;
      }
      if (key === 'po_line_number') {
        data.purchaseOrderId = data[key].id;
      }
      if (key === 'transporterId' || data.transporterId === null) {
        // if transporter is changed purchase order details should be set to null
        data.purchaseOrderId = null;
        data.po_number = null;
        data.account_assignment_number = null;
        data.po_line_number = null;
        if (!this.$hasFeature('transporter_based_vehicles')) {
          this.transporterSelectAll = $event && $event.length === this.transportersList.length;
        }
      }

      if (key === 'transporterId' && this.$hasFeature('transporter_based_vehicles')) {
        data = this.getUpdatedVehicleType(data);
        if (data.vehicleTypeId) this.fetchCompatibleVehicles();
      }
      if (key === 'freightType' && this.isNoFreightDefaultValues && data[key] === AppConstant.FreightType.PARTY_COLLECT) {
        data = this.getUpdatedDeliveryType(data);
        data = this.getDeliveryTypeDependentData(data);
      }
      if (key === 'freightRate' && data.open_freight_type === 9) {
        if (data[key] < 0 || data[key] > 100) {
          this.$error({ message: this.$getErr('PER_PERCENTAGE_FREIGHT_LIMIT') });
        }
        data.freightUnitConflict = data[key] < 0 || data[key] > 100;
      }
      if (key === 'freightRate' || key === 'open_freight_type') {
        this.$emit('freightUpdated', true);
      }

      if (key === 'open_freight_type' && this.isOpenIndent) {
        data.freightRate = 0;
      }
      this.$emit('changeIndentDetails', data);
    },
    // search purchase order fields
    searchPurchaseOrder: debounce(async function search(keyword, label) {
      if (keyword && label) {
        const params = {};
        params[label] = keyword;
        this.$emit('searchPurchaseOrder', params, label);
      }
    }, 300),
    getUpdatedTransporterId(updatedData) {
      const data = updatedData;
      if (!this.isOnlyChangeTruckState) {
        const transportersList = this.getTransportersList(data.vehicleTypeId, data.freightType, data.deliveryType);
        if (transportersList && transportersList.length === 1) {
          data.transporterId = transportersList[0].id;
        } else {
          data.transporterId = null;
          data.transporterName = null;
          this.$emit('updateTransporterName', '');
        }
      }
      return data;
    },
    getUpdatedVehicleType(updatedData) {
      const data = updatedData;
      const vehiclesTypes = this.getVehicleTypesList(data.transporterId, data.deliveryType, data.freightType);
      if (vehiclesTypes && vehiclesTypes.length === 1) {
        data.vehicleTypeId = vehiclesTypes[0].id;
      } else {
        data.vehicleTypeId = null;
      }
      return data;
    },
    getUpdatedDeliveryType(updatedData) {
      const data = updatedData;
      const types = this.getDeliveryTypeList(updatedData.freightType);

      if (types && types.length === 1) {
        data.deliveryType = types[0].id;
      } else {
        data.deliveryType = null;
      }
      return data;
    },
    getDeliveryTypeDependentData(data) {
      let updatedData = data;
      updatedData.vehicleTypeId = null;
      updatedData.transporterId = null;
      if (this.$hasFeature('transporter_based_vehicles')) {
        updatedData = this.getUpdatedTransporterId(updatedData);
        if (updatedData.transporterId) {
          updatedData = this.getUpdatedVehicleType(updatedData);
        } else {
          updatedData.vehicleTypeId = null;
        }
      } else {
        updatedData = this.getUpdatedVehicleType(updatedData);
        if (updatedData.vehicleTypeId) {
          updatedData = this.getUpdatedTransporterId(updatedData);
        } else {
          updatedData.transporterId = null;
        }
      }
      return updatedData;
    },
    searchListById(list, id) {
      return list.find(val => val.id === id) || {};
    },
    showDraft() {
      return this.$hasPermission('draft_indent');
    },
    getPurchaseOrderValue(label) {
      if (this.currentIndent[label]) {
        return this.currentIndent[label][label];
      }
      return null;
    },
    transporterBulkSelection(event) {
      this.transporterSelectAll = event;
      if (event) {
        this.changeIndentDetails(this.transportersList.map(t => t.id), 'transporterId');
      } else {
        this.changeIndentDetails([], 'transporterId');
      }
    },
    reviseIndentCreation() {
      this.$emit('closeIndentPrompt');
    },
    /**
     * Proceeds with Indent creation
     */
    createMultiplePtlIndents() {
      if (!this.isOrderProcessing) {
        this.$emit('createIndent', false);
      }
    },
    /**
     * To reset the store array and local variables on slider close
     */
    closeTransporterSlider() {
      this.$emit('hide-transporter-slider');
      this.showTransporterSlider = false;
      this.searchedTransporters = '';
      this.searchActive = false;
    },
    /**
     * To load the subsequent set of records on vertical scroll inside transporter pane
     */
    loadMore: debounce(function loadList(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (!this.disableLoader && !this.loadCheck && scrollTop + clientHeight >= scrollHeight * (4 / 5)) {
        this.loadCheck = true;
        // Manual implementation of virtual scroll
        setTimeout(async () => {
          await this.loadData(this.searchedTransporters);
          this.loadCheck = false;
        }, 500);
      }
    }, 500),
    /**
     * To load RFQ transporters list
     */
    async loadRfqTransporters(query = '') {
      const { sources, destinations } = await this.constructContractCheckPayload();
      const queryObject = {
        params: {
          page: this.page,
        },
        data: {
          sources,
          destinations,
          vehicleTypeId: this.currentIndent.vehicleTypeId,
          isInbound: (this.selectedType && this.selectedType !== '1'),
        },
      };
      if (query) {
        queryObject.params.name = query;
      }
      const transportersList = await this.$store.dispatch('mdm/searchTransporters', queryObject);
      if (transportersList.error) {
        return;
      }
      if (transportersList) {
        this.disableLoader = transportersList.length < 25;
        this.page += 1;
        transportersList.forEach(transporter => {
          if (this.checkedTransporters.includes(transporter.id) && 
              !this.storedSelectedTransporters.find(t => t.id === transporter.id)) {
            this.storedSelectedTransporters.push({
              id: transporter.id,
              name: transporter.name,
              location: (transporter.city && transporter.reference_id) ? `${transporter.city} - ${transporter.reference_id}` : '',
              contracts: transporter.additional_contracts,
              contract_id: transporter.contract_id,
            });
          }
        });
      }
      if (this.isAllTransportersSelected) {
        transportersList
          .forEach((_transporter) => {
            if (!this.checkedTransporters.includes(_transporter.id) &&
                !this.unselectedTransporters.includes(_transporter.id)) { // To prevent redundant id's and respect deselections
              this.checkedTransporters.push(_transporter.id);
            }
          });
        this.changeIndentDetails(this.checkedTransporters, 'transporterId');
      }
    },
    /**
     * Wrapper method that triggers methods to fetch rfq/non-rfq/contracted transporters
     */
    async loadData(query = '') {
      if (!this.$hasFeature('override_order_type') && (this.currentType === 0 || this.currentType === 2)) { // Contract Indent
        this.selectedTransporter = this.currentIndent && this.currentIndent.transporterId;
        this.selectedTransporterContractKey = this.selectedTransporter;
        if (this.selectedTransporter && this.getTransportersList()) {
          const transporter = this.getTransportersList()
            .find(entry => entry.id === this.selectedTransporter);
          if (this.$hasFeature('resist_query_enhancer') && transporter.contract_id) {
            this.selectedContractIds.push(transporter.contract_id);
            const match = this.getTransporterList.find(
              t => t.id === this.selectedTransporter &&
                  this.selectedContractIds.includes(t.contract_id),
            );
            if (match) {
              this.selectedTransporterContractKey = `${match.id}_${match.contract_id}`;
            }
          }
          if (transporter && (transporter.name || transporter.transporter_name)) {
            if (this.currentType === 0) { // contract case check
              this.$emit('updateTransporterName', transporter.transporter_name);
            } else {
              this.$emit('updateTransporterName', transporter.name); // no freight case
            }
          }
        }
        if (this.currentIndent.first_in_allotment && this.$hasFeature('first_in_allotment')) {
          this.checkDefaultTransporter();
        }
        this.disableLoader = true;
      } else if (this.currentType === 1 && this.currentIndent.rfq) {
        // RFQ Indent
        this.loadRfqTransporters(query);
      } else {
        // Non RFQ Open Indent
        await this.loadTransporters(query);
        if (this.selectedTransporter) {
          this.updateSelectedTransporter(this.selectedTransporter);
        }
      }
    },
    /**
     * To open Transporter Slider
     */
    async openTransporterSlider() {
      if (!this.shuffleActive) {
        this.$store.commit('mdm/initalReset', []);
        if (!this.showTransporterSlider) {
          this.showTransporterSlider = true;
          this.disableLoader = false;
          this.page = 1;
          this.loadData();
          this.$emit('open-transporter-slider');
        } else {
          this.closeTransporterSlider();
        }
      }
    },
    /**
     * Triggers when select-all checkbox is clicked inside transporter pane
     */
    async toggleSelectAllTransporters(val) {
      // If in partial-select state (some deselected), treat click as deselect-all
      const newVal = this.unselectedTransporters.length > 0 ? false : val;
      this.isAllTransportersSelected = newVal;
      this.checkedTransporters = [];
      this.unselectedTransporters = [];
      if (this.isAllTransportersSelected) {
        this.transportersList.forEach((transporter) => { // To prevent redundant id's from getting pushed
          if (!this.checkedTransporters.includes(transporter.id)) {
            this.checkedTransporters.push(transporter.id);
          }
        });
        const { sources, destinations } = await this.constructContractCheckPayload();
        const result = await this.$store.dispatch('mdm/countTransporters', {
          params: { page: 1 },
          data: {
            sources,
            destinations,
            vehicleTypeId: this.currentIndent.vehicleTypeId,
            isInbound: (this.selectedType && this.selectedType !== '1'),
          },
        });
        if (this.isAllTransportersSelected) {
          this.totalTransporterCount = result && result.total ? result.total : 0;
        }
      } else {
        this.totalTransporterCount = 0;
      }
      this.changeIndentDetails(this.checkedTransporters, 'transporterId');
      this.$emit('allTransportersSelected', this.isAllTransportersSelected);
    },
    /**
    * Debounce function to handle transporter search
    */
    filterTransporters: debounce(function transporterSearch() {
      if (this.searchedTransporters) {
        this.searchActive = true;
      } else {
        this.searchActive = false;
      }
      if ((this.currentType !== 0 && this.currentType !== 2) || (this.currentType === 0 && this.$hasFeature('override_order_type'))) {
        this.$store.commit('mdm/initalReset', []);
        this.page = 1;
        this.loadData(this.searchedTransporters);
      }
    }, 300),
    /**
     * To load non-rfq transporters
     */
    async loadTransporters(query = '') {
      let depotId = null;
      const { sources, destinations } = await this.constructContractCheckPayload();
      if (this.selectedType && this.selectedType !== '1') {
        depotId = destinations[0] && destinations[0].location_id;
      } else {
        depotId = sources[0] && sources[0].location_id;
      }
      const queryObject = {
        section: 'transporter',
        params: {
          depot_ids: depotId,
          status: 1,
          page: this.page,
        },
      };
      if (query) {
        queryObject.params.query = query;
      }
      const transporterList = await this.$store.dispatch('mdm/search', queryObject);
      if (this.currentIndent) {
        if (this.currentIndent.rfq && this.currentType === 1 && !this.isNoFreightIndent) {
          this.checkedTransporters = this.currentIndent.transporterId;
        } else {
          this.selectedTransporter = this.currentIndent.transporterId;
          this.selectedTransporterContractKey = this.selectedTransporter;
        }
      }
      if (transporterList) {
        this.disableLoader = transporterList.length < 25;
        this.page += 1;
      }
    },
    checkDefaultTransporter() {
      if (!Array.isArray(this.currentIndent.transporterId)) {
        this.currentIndent.transporterId = [];
      }
      this.transportersList.forEach((transporter) => {
        if (transporter.contracts && transporter.contracts.length > 0) {
          transporter.contracts.forEach((contract) => {
            if (contract.transporter_id && this.checkedTransporters.length < 25 &&
             !this.checkedTransporters.includes(contract.transporter_id)) {
              this.checkedTransporters.push(contract.transporter_id);
              this.currentIndent.transporterId.push(contract.transporter_id);
            }
          });
        }
      });
    },
    /**
     * To update the parent with the selected transporter Id for non-rfq case
     */
    updateSelectedTransporter(evt, contractId) {
      this.transportersList.forEach(transporter => {
        if (this.checkedTransporters.includes(transporter.id) && 
            !this.storedSelectedTransporters.find(t => t.id === transporter.id)) {
          this.storedSelectedTransporters.push(transporter);
        }
      });
      const transporter = this.getTransporterList.find((_transporter) => {
        if (this.restrictQueryEnhancerEnabled) {
          return _transporter.id === evt && _transporter.contract_id === contractId;
        }
        return _transporter.id === evt;
      });
      const transporterName = transporter ? transporter.name : '';
      this.changeIndentDetails(evt, 'transporterId');
      this.$emit('updateTransporterName', transporterName);
      this.clearCompatibleVehicle();
      if (evt) this.fetchCompatibleVehicles();
    },
    isSelectedTransporter(transporter) {
      if (this.restrictQueryEnhancerEnabled) {
        return transporter.id === this.selectedTransporter
        && this.selectedContractIds.includes(transporter.contract_id);
      }
      return transporter.id === this.selectedTransporter;
    },
    updateSelection(val, transporterId) {
      if (this.isAllTransportersSelected) {
        if (!val) {
          if (!this.unselectedTransporters.includes(transporterId)) {
            this.unselectedTransporters.push(transporterId);
          }
          // Any deselection means we no longer have "all" selected — tell backend to use the explicit list
          this.$emit('allTransportersSelected', false);
          if (this.totalTransporterCount > 0 &&
              this.unselectedTransporters.length >= this.totalTransporterCount) {
            this.isAllTransportersSelected = false;
            this.unselectedTransporters = [];
            this.checkedTransporters = [];
            this.totalTransporterCount = 0;
          }
        } else {
          const index = this.unselectedTransporters.indexOf(transporterId);
          if (index !== -1) this.unselectedTransporters.splice(index, 1);
          // If all unselected are re-selected, restore the all-selected state
          if (this.unselectedTransporters.length === 0) {
            this.$emit('allTransportersSelected', true);
          }
        }
      } else {
        if (this.disableLoader && !this.searchActive && this.checkedTransporters.length === this.getTransporterList.length) {
          this.isAllTransportersSelected = true;
          this.$emit('allTransportersSelected', this.isAllTransportersSelected);
        }
      }
    },
    openShufflePane() {
      if (!this.showTransporterSlider) {
        this.shuffleActive = !this.shuffleActive;
        if (this.shuffleActive) {
          this.$emit('open-transporter-slider');
        } else {
          this.$emit('hide-transporter-slider');
        }
      }
    },
    /**
     * Get initial sequence
     */
    setSequence(list) {
      try {
        if (this.lastMileEnabled) {
          const flattedPickupDrops = this.getFlattenedData();
          const payload = this.constructCheckPayload(flattedPickupDrops, list);
          if (payload) {
            this.$refs.viewPickupDropTimeline.syncPreviousList();
            this.$emit('update-sequence-data', this.sequenceData);
          }
        }
      } catch (error) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    getFlattenedData() {
      return this.sourcesDropOffs.reduce((acc, sourceDropOffDetail) => {
        const sourceDetail = {
          type: parseInt(sourceDropOffDetail.type, 10),
          location_id: sourceDropOffDetail.id, // source id
          pointType: 'pickup',
        };
        sourceDropOffDetail.pickups.forEach((pickup) => {
          let pickupDetails;
          if (sourceDetail.type === sourceAndDestinationType.CONSIGNEE) {
            pickupDetails = {
              ref_id: sourceDropOffDetail.reference_id,
            };
          } else {
            pickupDetails = {
              gate_id: pickup.id, // source gate id
              ref_id: pickup.reference_id,
            };
          }
          acc.push({ ...sourceDetail, ...pickupDetails });
          if (pickup.dropoffs) {
            pickup.dropoffs.forEach((drop) => {
              const destination = this.getDropPayload(drop, sourceDetail, pickup, 'drop', true);
              acc.push(destination);
            });
          }
        });
        return acc;
      }, []);
    },

    constructCheckPayload(flattedPickupDrops, comparator) {
      const payload = {
        sources: [],
        destinations: [],
      };
      this.sequenceData = {
        sources: [],
        destinations: [],
      };
      let sequence = 1;
      comparator.forEach((entry) => {
        const matchingEntry = flattedPickupDrops.find(record => (record.ref_id === entry.ref_id && record.pointType === entry.type));
        if (matchingEntry) {
          const sequenceEntry = { ...matchingEntry };
          delete matchingEntry.ref_id;
          delete matchingEntry.pointType;
          if (entry.type === 'pickup') {
            delete matchingEntry.source_location_id;
            delete matchingEntry.source_gate_id;
            payload.sources.push({ ...matchingEntry, sequence });
            this.sequenceData.sources.push({ ...sequenceEntry, sequence });
          } else {
            payload.destinations.push({ ...matchingEntry, sequence });
            this.sequenceData.destinations.push({ ...sequenceEntry, sequence });
          }
        }
        sequence += 1;
      });
      return payload;
    },
    setOrderType(orderType) {
      this.$emit('set-order-type', orderType);
    },
    async getSobDetails(vehicleTypeId) {
      if (this.$hasFeature('override_order_type')) {
        return;
      }
      if (this.currentIndent.transporterId && this.showSobAndFreightDetails) {
        const contractList = this.getVehicleTypesList();
        const payload = {
          sources: [],
          destinations: [],
        };
        this.sourcesDropOffs.forEach((sourceDropOffDetail) => {
          const source = {
            type: parseInt(sourceDropOffDetail.type, 10),
            location_id: sourceDropOffDetail.id,
          };
          sourceDropOffDetail.pickups.forEach((pickup) => {
            payload.sources.push({ ...source });
            pickup.dropoffs.forEach((drop) => {
              const destination = {
                type: parseInt(drop.ship_to.type, 10),
              };
              payload.destinations.push(destination);
            });
          });
        });
        const transporterId = this.currentIndent.transporterId;
        let maxRateContractId = null;
        let maxRate = 0;
        contractList.forEach((contract) => {
          if (contract.transporters) {
            contract.transporters.forEach((transporter) => {
              if (transporter.additional_contracts && transporter.additional_contracts.length) {
                transporter.additional_contracts.forEach((c) => {
                  if (c.vehicle_type_id === vehicleTypeId && c.transporter_id === transporterId && c.rate > maxRate) {
                    maxRate = c.rate;
                    maxRateContractId = c.contract_id;
                  }
                });
              } else {
                maxRate = transporter.rate;
                maxRateContractId = transporter.contract_id;
              }
            });
          }
        });
        if (maxRateContractId) {
          this.sob = await this.$store.dispatch('order/idealAndRunningSob', {
            contract_id: maxRateContractId,
            transporter_id: this.currentIndent.transporterId,
            sources: payload.sources,
            destinations: payload.destinations,
          });
        }
      }
    },
    isTransporterSelected(transporter) {
      return (
        transporter.id === this.selectedTransporter
        && this.selectedContractIds.includes(transporter.contract_id)
      );
    },
    getLabel(transporter) {
      let label = transporter.id;
      if (this.restrictQueryEnhancerEnabled && transporter.contract_id) {
        label = `${transporter.id}_${transporter.contract_id}`;
      }
      return label;
    },
  },
};
</script>
<style lang="scss" scoped>
.transporter-green-border {
  border:0.8px solid #1FCD93;
  border-radius: 2px;
}
.arrow-indicator  {
  &:hover {
    -ms-transform: scale(1.5); /* IE 9 */
    -webkit-transform: scale(1.5); /* Safari 3-8 */
    transform: scale(1.6, 1.2);
  }
}
</style>
